module.exports = __webpack_public_path__ + "img/sisley_club.cee7f417.svg";